/*
 * context-suggestions-pending-badge
 */
import { useTranslation } from "react-i18next"
import { trpc } from "../../trpc"
import { FeatureBadge } from "./feature-badge"

export function ContextSuggestionsPendingBadge() {
	const { t } = useTranslation()
	const { data } = trpc.contextSuggestion.getPendingCount.useQuery()

	if (!data?.count || data.count < 0) {
		return null
	}

	return (
		<FeatureBadge
			label={t("features.contextSuggestions.badgePending", {
				count: data.count,
			})}
			variant="secondary"
		>
			{data.count}
		</FeatureBadge>
	)
}
